import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';

export * from './dtos/create-vehicle-group.dto';
export * from './dtos/update-vehicle-group.dto';
export * from './dtos/vehicle-groups-stats.dto';
export * from './dtos/vehicle-group-list.dto';
export * from './dtos/vehicle-group-record.dto';
export * from './dtos/vehicle-group-activity-event.dto';
export * from './dtos/vehicle-group-activity-event-hydration.dto';
export * from './dtos/vehicle-group-search.dto';

export * from './types/vehicle-groups-filters';

export * from './validators/schemas/create-vehicle-group.schema';
export * from './validators/schemas/update-vehicle-group.schema';

export const vehicleGroupValidators = {
  canCreateOrUpdate,
};
